import { addClass, removeClass, hasClass } from './vendor/plugins.js';

// ---------------
// Address Lookups
// ---------------
var searchContext = "",
	key = "pz78-em24-pw89-ej93";

$(document).ready(function() {
	$('.js-form-pack')
		.each(function(index, elForm){
			var elSelect = elForm.querySelector('.js-form-pack-select'),
				elAddr = elForm.querySelector('.side-form_address'),
				elAddrFields = elForm.querySelector('.side-form_address-fields'),
				elAddrInputs = elForm.querySelectorAll('.address-input'),
				elAddrEdit = elForm.querySelector('.side-form_address-edit'),
				elAddr1 = elAddrInputs[0],
				elTriggerValidation = elForm.querySelector('.js-trigger-validation'),
				elPostcode = document.getElementById('request-postcode'),
				elSubmit = elForm.querySelector('button[type="submit"]'),
				_form = $(elForm);

			_form.attr('action', _form.data('action'));

			_form
				.validate({
					errorContainer: elForm.querySelector('.js-error-container'),
					errorLabelContainer: elForm.querySelector('.js-error-container'),
					submitHandler: function(form){
						if (hasClass(elAddrFields, 'show') || $('.side-form_address-select option:selected').val() != '') {
							if (elSubmit) {
								elSubmit.disabled = true;
								elSubmit.innerText = 'Submitting...';
							}

							form.submit();
						} else {
							$.ajax({
								url: "//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Find/v2.10/json3.ws",
								dataType: "jsonp",
								data: {
									key: key,
									searchFor: "Everything",
									searchTerm: $("#request-postcode").val(),
									lastId: searchContext
								},
								success: function(data) {
									var _options = ['<option value="">Please select your address</option>']
									$.each(data.Items, function(k,item) {
										_options.push('<option value="'+item.Id+'">'+item.Text+'</option>')
									});
									$('.side-form_address-select').html(_options.join(''));
								}
							});

							addClass(elAddr, 'show');
						}
					},
					wrapper: 'div'
				});

			$(elPostcode)
				.on('input change', function(){
					if (elPostcode.value.length < 5) return;

					if (hasClass(elAddr, 'show')) {
						$('.side-form_address-select').html('<option value="">Getting addresses...</option>');

						$.ajax({
							url: "//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Find/v2.10/json3.ws",
							dataType: "jsonp",
							data: {
								key: key,
								searchFor: "Everything",
								searchTerm: $("#request-postcode").val(),
								lastId: searchContext
							},
							success: function(data) {
								var _options = ['<option value="">Please select your address</option>']
								$.each(data.Items, function(k,item) {
									_options.push('<option value="'+item.Id+'">'+item.Text+'</option>')
								});
								$('.side-form_address-select').html(_options.join(''));
							}
						});
					}
				});

			$(elTriggerValidation)
				.on('click', function(){
					removeClass(elAddrFields, 'show');

					if (_form.valid()) {
						addClass(elAddr, 'show');
					}
				});

			$(elSelect)
				.on('change', function(event){
					addClass(elAddrEdit, 'show');

					$.ajax({
						url: "//services.postcodeanywhere.co.uk/CapturePlus/Interactive/Retrieve/v2.10/json3.ws",
						dataType: "jsonp",
						data: {
							key: key,
							id: elSelect.value
						},
						success: function (data) {
							if (data.Items.length) {
								var _ad = data.Items[0];

								$('.addr1').val(_ad.Line1);
								$('.addr2').val(_ad.Line2);
								$('.addr3').val(_ad.Line3);
								$('.town').val(_ad.City);
								$('.county').val(_ad.Province);
							}
						}
					});

				});

			$(elAddrEdit)
				.on('click', '.js-address-edit', function(event){
					addClass(elAddrFields, 'show');
				});
		});
})

// Cookie check
var searchString = window.location.search.substring(1)
	, Parameters = new Object()
	, nameValuePairs = searchString.split(/&/)
	, nameValuePair
	, name
	, value
	, _domain = window.location.hostname.replace('www.','');


if (window.location.pathname == '/ideal/') {
    SetCookie('adidoPGFC', 'IDTV', largeExpDate, '/', '.' + _domain);
}

if (searchString.length > 0) {
	for (var i = 0; i < nameValuePairs.length; i++) {
		nameValuePair = nameValuePairs[i].split(/=/);
		name = nameValuePair[0];
		value = unescape(nameValuePair[1]);
		name = name.toLowerCase();
		var largeExpDate = new Date();
		largeExpDate.setTime(largeExpDate.getTime() + (30 * 24 * 3600 * 1000));
		if (name == "awc") {
			if (typeof (value) != "undefined") {
				SetCookie("adidoPGFC", value.toLowerCase(), largeExpDate, '/', '.'+	_domain);
			}
		} else if (name == "aid") {
			if (typeof (value) != "undefined") {
				SetCookie("adidoPGFC-AID", value.toLowerCase(), largeExpDate, '/', '.' + _domain);
			}
		} else if (name == "referrerID") {
			if (typeof (value) != "undefined") {
				SetCookie("adidoPGFC", "REF_" + value.toLowerCase(), largeExpDate, '/', '.' + _domain);
			}
		} else if (name == "hpj") {
			if (typeof (value) != "undefined") {
				SetCookie("adidoPGFC", "HPJ_" + value.toLowerCase(), largeExpDate, '/', '.' + _domain);
			}
		} else if (name == "gclid") {
			if (typeof (value) != "undefined") {
				var gclsrc = getParam('gclsrc');
				if (!gclsrc || gclsrc.indexOf('aw') !== -1) {
					SetCookie("adidoPGFC-GCLID", value, largeExpDate, '/', '.' + _domain);
				}
			}
		} else if (name == "msclkid") {
			if (typeof (value) != "undefined") {
				SetCookie("adidoPGFC-GCLID", value, largeExpDate, '/', '.' + _domain);
			}
		} else if (name == "keyword") {
			if (typeof (value) != "undefined") {
				SetCookie("adidoPGFC-KW", unescape(value).toLowerCase(), largeExpDate, '/', '.' + _domain);
			}
		} else if (name == "matchtype") {
			if (typeof (value) != "undefined") {
				SetCookie("adidoPGFC-MT", unescape(value).toLowerCase(), largeExpDate, '/', '.' + _domain);
			}
		} else if (name == "gbraid" || name == 'wbraid') {
			if (typeof (value) != "undefined") {
				SetCookie("adidoPGFC-BRAID", unescape(value).toLowerCase(), largeExpDate, '/', '.' + _domain);
			}
		}
	}
} else if (document.referrer != "" && document.referrer.indexOf(_domain) == -1) {
	var largeExpDate = new Date();
	largeExpDate.setTime(largeExpDate.getTime() + (30 * 24 * 3600 * 1000));
	if (document.referrer.indexOf("http://www.google") > -1) {
		SetCookie("adidoPGFC", "ORGANICG", largeExpDate, '/', '.' + _domain);
		SetCookie("adidoPGFC-KW", unescape(document.referrer.substring(document.referrer.indexOf('q=') + 2, document.referrer.indexOf('&ei'))).toLowerCase(), largeExpDate, '/', '.' + _domain);
	} else if (document.referrer.indexOf("http://www.yahoo") > -1) {
		SetCookie("adidoPGFC", "ORGANICY", largeExpDate, '/', '.' + _domain);
		SetCookie("adidoPGFC-KW", unescape(document.referrer.substring(document.referrer.indexOf('p=') + 2, document.referrer.indexOf('&fr2'))).toLowerCase(), largeExpDate, '/', '.' + _domain);
	} else if (document.referrer.indexOf("http://www.bing") > -1) {
		SetCookie("adidoPGFC", "ORGANICB", largeExpDate, '/', '.' + _domain);
		SetCookie("adidoPGFC-KW", unescape(document.referrer.substring(document.referrer.indexOf('q=') + 2, document.referrer.indexOf('&go'))).toLowerCase(), largeExpDate, '/', '.' + _domain);
	} else {
		SetCookie("adidoPGFC", "REFERRER", largeExpDate, '/', '.' + _domain);
		SetCookie("adidoPGFC-KW", "", largeExpDate, '/', '.' + _domain);
	}
}

//////////////////functions////////////////////////////////////////////////
function getParam(p) {
	var match = RegExp('[?&]' + p + '=([^&]*)').exec(window.location.search);
	return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
}
function SetCookie(name, value, expires, path, domain, secure) {
	expires = (expires !== undefined) ? expires : null;
	path = (path !== undefined) ? path : null;
	domain = (domain !== undefined) ? domain : null;
	secure = (secure !== undefined) ? secure : false;
	document.cookie = name + "=" + escape(value) +
		((expires == null) ? "" : ("; expires=" + expires.toGMTString())) +
		((path == null) ? "" : ("; path=" + path)) +
		((domain == null) ? "" : ("; domain=" + domain)) +
		((secure == true) ? "; secure" : "");
}
function getCookieVal(offset) {
	var endstr = document.cookie.indexOf(";", offset);
	if (endstr == -1)
		endstr = document.cookie.length;
	return unescape(document.cookie.substring(offset, endstr));
}
function GetCookie(name) {
	var arg = name + "=";
	var alen = arg.length;
	var clen = document.cookie.length;
	var i = 0;
	while (i < clen) {
		var j = i + alen;
		if (document.cookie.substring(i, j) == arg)
			return getCookieVal(j);
		i = document.cookie.indexOf(" ", i) + 1;
		if (i == 0)
			break;
	}
	return null;
}
function DeleteCookie(name, path, domain) {
	if (GetCookie(name)) document.cookie = name + "=" +
		((path) ? ";path=" + path : "") +
		((domain) ? ";domain=" + domain : "") +
		";expires=Thu, 01-Jan-1970 00:00:01 GMT";
}
function setDifferentClass(tabID, destID) {
	var currTabElem = document.getElementById(tabID);
	var targetclass = destID;
	currTabElem.setAttribute("class", targetclass);
	currTabElem.setAttribute("className", targetclass);
	return;
}
function changeText(textID, NewText) {
	document.getElementById(textID).innerHTML = NewText;
}
function showHideLayer(layerid, v) {
	var thelayer = document.getElementById(layerid);
	thelayer.style.visibility = v;
}
function setImage(imgName, newImgSrc) {
	var temp;
	temp = "document.images." + imgName + ".src = '" + newImgSrc + "'";
	eval(temp);
}

export { key, searchContext };